import React from 'react';

import * as styles from './BottleSticker.styles';

export interface BottleStickerProps {
  content: string;
}

export const BottleSticker = ({ content }: BottleStickerProps) => {
  return (
    <div css={styles.container}>
      <img
        src="https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt4b24054ee833abd4/dark_purple_bottle.png"
        alt={content}
      />
    </div>
  );
};
